import React, { useState, useEffect } from "react";
import { FaNetworkWired } from "react-icons/fa";
// import img from "../../secondAssets/Images/modernTitle1.jpeg";
import { portfolioImgSrc } from "../../secondUtils/constants";

const getRandomIndices = (length, count, excludeIndex) => {
    let indices = new Set();
    while (indices.size < count) {
        const randomIndex = Math.floor(Math.random() * length);
        if (randomIndex !== excludeIndex) {
            indices.add(randomIndex);
        }
    }
    return Array.from(indices);
};

const PortfolioCardComponent = ({name,heading,img}) => {
    const [imagesToShow, setImagesToShow] = useState([]);

    useEffect(() => {
        const matchIndex = portfolioImgSrc.findIndex(image => image === img);

        let initialImages = matchIndex !== -1 ? [portfolioImgSrc[matchIndex]] : [];

        if (matchIndex !== -1) {
            const randomIndices = getRandomIndices(portfolioImgSrc.length, 2, matchIndex);
            initialImages = initialImages.concat(randomIndices.map(index => portfolioImgSrc[index]));
        }

        setImagesToShow(initialImages);
    }, []);

    return (
        <div className="main">
            <div className="portfolio-card-screen-main">
                <div className="portfolio-card-screen-text-div">
                    <h2>{heading}</h2>
                    <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don’t look even slightly believable.</p>
                    <p>Aenean leo ligula, porttitor eu, consequat vitae, eleifend ac, enim. Aliquam lorem ante, dapibus in, viverra quis, feugiat a, tellus.</p>
                    <button><FaNetworkWired className="portfolio-network-icon" /> {name}</button>
                </div>
                <div className="portfolio-card-screen-img-div">
                    <img src={img} alt="" />
                    {/* <div>
                        {imagesToShow.map((image, index) => (
                            <div key={index}>
                                <img
                                    className="portfolioModal-small-image"
                                    src={image}
                                    alt={`Preview ${index}`}
                                />
                            </div>
                        ))}
                    </div> */}
                </div>
            </div>
        </div>
    );
};

export default PortfolioCardComponent;
